// extracted by mini-css-extract-plugin
export var cardIcon = "_ap-4";
export var checkboxCard = "_ap-0";
export var checkboxCardSelected = "_ap-3";
export var disabled = "_ap-1";
export var outerBorder = "_ap-2";
export var spacerMedium = "_ap-7";
export var spacerSmall = "_ap-6";
export var spacerXsmall = "_ap-5";